import {useHttp} from "../../../context/HttpProvider";
import {useEffect, useState} from "react";
import MapEntity from "./MapEntity";
import { ContinueAction } from "../ReportWizardProvider";
import useValueMapping from "./hooks/useValueMapping";

export default function WholesalerMapper() {
    const {mappingApi} = useHttp();
    const [hasLoaded, setHasLoaded] = useState(false);
    const [reportUploadId, mappingData, setMappingData, updateMapping, validate, validationLookup] = useValueMapping(ContinueAction.SaveWholesalerMappings);

    async function getWholesalerMappings() {
        var response = await mappingApi.getWholesalerMappings(reportUploadId);
        if(response) {
            setMappingData(response);
            setHasLoaded(true);
            validate(response);
        }
    }

    useEffect(() => {
        if(mappingApi != null) {
            getWholesalerMappings();
        }
    }, [mappingApi])

    return <>
        {hasLoaded && <MapEntity data={mappingData} type="Wholesaler" updateMapping={updateMapping} validationLookup={validationLookup} />}
    </>
}